import { useState, useEffect } from 'react';
import { getCart } from '@/utils/api';

/**
 * Custom hook to get cart item count
 * Updates whenever the component mounts or cart changes
 */
export const useCartCount = (user) => {
  const [cartCount, setCartCount] = useState(0);

  const fetchCartCount = async () => {
    if (!user) {
      setCartCount(0);
      return;
    }

    try {
      const response = await getCart();
      setCartCount(response.data?.length || 0);
    } catch (error) {
      console.error('Failed to fetch cart count:', error);
      setCartCount(0);
    }
  };

  useEffect(() => {
    fetchCartCount();
    
    // Listen for custom cart update event
    const handleCartUpdate = () => {
      fetchCartCount();
    };
    
    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [user]);

  return { cartCount, refreshCartCount: fetchCartCount };
};
